import 'babel-polyfill';
import Vue from 'vue';
import ElementUI from 'element-ui';
// 引入 Element 的主题文件
import 'element-ui/lib/theme-chalk/index.css';
// import Vconsole from 'vconsole';
import App from './App.vue';
import router from './router';
import store from './store';
// 引入自定义的全局样式文件
import './styles/reset.css';
// lib-flexible/flexible + px2rem-loader px转换rem flexible.js 文件 72行 540 改为 width;
import 'lib-flexible/flexible';

// 微信调试工具
// const vConsole = new Vconsole();
// Vue.use(vConsole);

Vue.use(ElementUI);

Vue.config.productionTip = false;

// Vue.config.ignoredElements = ['wx-open-launch-weapp'];

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
